const NAME_REGEX = /^[A-Za-z][A-Za-z\s'.-]*$/;

export function formatNameInput(value: string): string {
  return value.replace(/[^A-Za-z\s'.-]/g, "").slice(0, 50);
}

export function isValidPersonName(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length >= 2 && NAME_REGEX.test(trimmed);
}

export const PERSON_NAME_REGEX = NAME_REGEX;
